module.exports = __webpack_public_path__ + "static/media/MY-APU.b5e26973.png";